<template>
  <div class="eventDesc">
    <!--会议信息描述区域-->
    <el-row class="nofull">
      <el-row :gutter="30">
        <el-col :span="18">
          <router-view></router-view>
          <div class="event_desc">
            <el-image
              :src="
                '/forum-pub-api/v1/minio/getFile?file_url=' +
                eventDesc.image_url
              "
              fit="cover"
            >
              <div slot="error" class="image-slot">
                <div class="errText">{{ eventDesc.name }}</div>
                <img
                  class="el-image__inner"
                  style="object-fit: cover"
                  src="../assets/errbg.jpg"
                />
              </div>
            </el-image>
            <div class="event_info">
              <div class="event_title">{{ eventDesc.name }}</div>
              <div class="event_meta">
                <div class="meta_row">
                  {{ orgLabel }}：<span>{{
                    eventDesc.setting_json.orgnizer
                  }}</span>
                </div>
                <div class="meta_row">
                  承办单位：<span>{{ eventDesc.setting_json.undertaker }}</span>
                </div>
                <time class="meta_row"
                  >{{ sDate }}：<span>{{
                    changetoLocaleString(eventDesc.start_time)
                  }}</span></time
                >
                <time class="meta_row"
                  >{{ eDate }}：<span>{{
                    changetoLocaleString(eventDesc.end_time)
                  }}</span></time
                >
                <div class="meta_row">
                  举办城市：<span>{{ eventDesc.setting_json.city }}</span>
                </div>
                <div class="meta_row">
                  会议地址：<span>{{ eventDesc.setting_json.address }}</span>
                </div>
                <div class="meta_row">
                  {{ maxPeopleLabel }}：<span>{{
                    eventDesc.setting_json.max_people
                  }}</span>
                </div>
              </div>
              <!--
                            <div class="event_meta">
                                <div class="meta_row">{{ contactsLabel }}：<span>{{ eventDesc.contacts }}</span></div>
                                <div class="meta_row">{{ telLabel }}：<span>{{ eventDesc.tel }}</span></div>
                            </div>
                            -->
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="event_active_box">
            <div class="event_active">
              <div class="active_title">我要参会</div>
              <div class="submitBtnBox">
                <el-button
                  type="primary"
                  :disabled="blSubmitBtn"
                  @click="handleShowThesisForm"
                  >{{ tougao }}</el-button
                >
                <div class="button_info">
                  投稿开放时间:<br />
                  {{
                    changetoLocaleString(
                      eventDesc.setting_json.contribute_start_time,
                    )
                  }}
                  -
                  {{
                    changetoLocaleString(
                      eventDesc.setting_json.contribute_end_time,
                    )
                  }}
                </div>
              </div>
              <div class="regBtnBox">
                <el-button
                  type="success"
                  :disabled="blRegBtn"
                  @click="handleShowRegistrationForm"
                  >{{ baoming }}</el-button
                >
                <div class="button_info">
                  报名开放时间:<br />
                  {{
                    changetoLocaleString(
                      eventDesc.setting_json.registion_start_time,
                    )
                  }}
                  -
                  {{
                    changetoLocaleString(
                      eventDesc.setting_json.registion_end_time,
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-row>
    <!--报名表抽屉-->
    <RegistrationForm
      @blRegistrationForm="blRegistrationForm"
      :blRegBtn="blRegBtn"
      @blBtn="blBtn"
      :showRegistrationForm="showRegistrationForm"
      :eventTitle="eventDesc.name"
      :eventId="forumId"
    />
    <ThesisForm
      ref="child"
      :fields="fields"
      :eventTitle="eventDesc.name"
      :eventId="forumId"
    />
  </div>
</template>

<script>
import RegistrationForm from '@/components/RegistrationForm';
import ThesisForm from '@/components/ThesisForm';
// import {getEventDetail} from "@/apis/eventDetail";
import { getDomain } from '@/apis/domain';
import { getEventDetail } from '@/apis/eventDetail';
import { getRegistration } from '@/apis/registration';

export default {
  name: 'EventDesc',
  components: {
    RegistrationForm,
    ThesisForm,
  },
  props: {},
  mounted() {
    this.$emit('activeIndex', '2');
    this.$emit('pageClass', 'event');
    let forum_id = this.$route.query.eventId;
    // console.log( 'desc' + forum_id);
    this.forumId = Number(forum_id);
    getDomain(forum_id)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            this.fields = res.data.data.items;
          } else {
            this.$message.error(res.data.message);
          }
        } else {
          this.$message.error('未请求成功');
          console.log('错误');
        }
      })
      .catch((error) => {
        console.log(error);
      });

    getRegistration({ forum_id: forum_id }).then((res) => {
      if (res.status === 200 && res.data?.data?.registration_status === 1) {
        this.registrated = true;
      }
    });
    getEventDetail(forum_id)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            //  console.log(res.data);
            this.$store.commit('AddCurrentEvent', res.data.data.item);
            this.$store.commit(
              'AddSettingJson',
              res.data.data.item.setting_json,
            );
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success',
            });
          }
        } else {
          this.$message.error('未请求成功');
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // 获取学者

    /*
            getEventDetail(forum_id).then(res => {
                if ( res.status === 200 ) {
                    if ( res.data.success === true ){
                        console.log(res.data);
                        this.eventDesc = res.data.data.item
                        this.eventDesc.setting_json = res.data.data.item.setting_json
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'success',
                        });
                    }
                } else {
                    this.$message.error('未请求成功');
                }
            }).catch(error => {
                console.log(error);
            });*/
  },
  computed: {
    eventDesc: {
      get() {
        return this.$store.state.toGetCurrentEvent.currentEvent;
      },
    },
    blRegBtn: {
      get() {
        if (this.registrated) return false;
        const now = this.$moment(this.eventDesc.server_time);
        return !now.isBetween(
          this.$moment(this.eventDesc.setting_json.registion_start_time),
          this.$moment(this.eventDesc.setting_json.registion_end_time),
        );
      },
    },
    baoming: {
      get() {
        if (this.registrated) return '已报名';
        const now = this.$moment(this.eventDesc.server_time);
        if (
          this.$moment(this.eventDesc.setting_json.registion_end_time).isBefore(
            now,
          )
        ) {
          return '报名已截止';
        } else if (
          this.$moment(
            this.eventDesc.setting_json.registion_start_time,
          ).isAfter(now)
        ) {
          return '报名未开始';
        } else {
          return '报名';
        }
      },
    },
    blSubmitBtn: {
      get() {
        const now = this.$moment(this.eventDesc.server_time);
        return !now.isBetween(
          this.$moment(this.eventDesc.setting_json.contribute_start_time),
          this.$moment(this.eventDesc.setting_json.contribute_end_time),
        );
      },
    },
    tougao: {
      get() {
        const now = this.$moment(this.eventDesc.server_time);
        if (
          this.$moment(
            this.eventDesc.setting_json.contribute_end_time,
          ).isBefore(now)
        ) {
          return '投稿已截止';
        } else if (
          this.$moment(
            this.eventDesc.setting_json.contribute_start_time,
          ).isAfter(now)
        ) {
          return '投稿未开始';
        } else {
          return '投稿';
        }
      },
    },
  },
  data() {
    return {
      // 会议基本信息
      forumId: null,
      orgLabel: '主办单位',
      sDate: '开始时间',
      eDate: '结束时间',
      contactsLabel: '联系人',
      telLabel: '电话',
      locationLabel: '会议地点',
      maxPeopleLabel: '人数限制',
      contribute_end_time2: '',
      registion_end_time2: '',

      fields: [],
      showRegistrationForm: false,
      showThesisForm: false,
      registrated: false,
      // blRegBtn: false,
      // blSubmitBtn: false,
    };
  },
  methods: {
    compareDate(dt1, dt2) {
      let x1 = new Date(dt1.getFullYear(), dt1.getMonth(), dt1.getDate());
      let x2 = new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate());

      return x1.getTime() - x2.getTime();
    },
    changetoLocaleString(str) {
      if (str) {
        // let localeTime = new Date(str);
        // return this.common.dateFormat("YYYY/mm/dd", localeTime)
        return this.$moment(str).format('YYYY-MM-DD');
      } else {
        return str;
      }
    },
    handleShowRegistrationForm() {
      if (this.registrated) {
        this.$router.push({
          path: `/myRegistrationForm`,
          query: { eventId: this.$route.query.eventId },
        });
      } else if (
        localStorage.eleToken !== null &&
        localStorage.eleToken !== '' &&
        localStorage.eleToken !== undefined &&
        this.$store.state.toGetCurrentUser.isLoginKey === 1
      ) {
        this.showRegistrationForm = true;
      } else {
        this.$store.commit('blOpenLoginBox', true);
      }
    },
    blRegistrationForm(v) {
      this.showRegistrationForm = v;
    },
    blBtn(val) {
      this.blRegBtn = val;
    },
    handleShowThesisForm() {
      if (
        localStorage.eleToken !== null &&
        localStorage.eleToken !== '' &&
        localStorage.eleToken !== undefined &&
        this.$store.state.toGetCurrentUser.isLoginKey === 1
      ) {
        this.$refs.child.openForm();
      } else {
        this.$store.commit('blOpenLoginBox', true);
      }
    },
  },
};
</script>

<style scoped></style>
